import { IJobSuggestions } from 'wisestep-api';
import { formattedDateISO, getDateUsingFormat, IFilterList } from 'wisestep-base';

import { JobAdvanceFilterFormProps } from '../../../components/filters';

import {
  transformClientRecruitersToEmailArray,
  transformIClientDTOsToStringArray,
} from './JobHelperService';

export const pushJobsFilters = (data: JobAdvanceFilterFormProps) => {
  const filtersArray: IFilterList[] = [];

  if (data.clientRecruiterList?.length)
    filtersArray.push({
      tag: `Client Recruiters: ${transformClientRecruitersToEmailArray(
        data.clientRecruiterList
      ).join(',')}`,
      id: 'clientRecruiterList',
    });
  if (data.clientList?.length)
    filtersArray.push({
      tag: `Clients: ${transformIClientDTOsToStringArray(data.clientList).join(',')}`,
      id: 'clientList',
    });
  if (data.jobBoards) filtersArray.push({ tag: `Job Board: ${data.jobBoards}`, id: 'jobBoards' });
  if (data.jobStatus) filtersArray.push({ tag: `Job Status: ${data.jobStatus}`, id: 'jobStatus' });
  if (data.businessUnit) {
    const labelIndex = data.businessUnit.indexOf('label');
    filtersArray.push({
      tag: `Business Unit: ${data.businessUnit.substring(labelIndex + 5)}`,
      id: 'businessUnit',
    });
  }

  if (data.jobType) filtersArray.push({ tag: `Job Type: ${data.jobType}`, id: 'jobType' });
  if (data.hiringFor) filtersArray.push({ tag: `Hiring For: ${data.hiringFor}`, id: 'hiringFor' });
  if (data.locations?.length)
    filtersArray.push({
      tag: `Locations: ${data.locations
        .map((location) => `${location.city}-${location.state}-${location.country}`)
        .join(',')}`,
      id: 'locations',
    });
  if (data.recruiters?.length)
    filtersArray.push({
      tag: `Recruiters: ${data.recruiters.join(',')}`,
      id: 'recruiters',
    });
  if (data?.tags && data?.tags?.length > 0)
    filtersArray.push({
      tag: `Tags: ${data.tags.join(', ')}`,
      id: 'tags',
    });
  if (data?.jobSource && data?.jobSource?.length > 0)
    filtersArray.push({
      tag: `Job Source: ${data.jobSource.join(', ')}`,
      id: 'jobSource',
    });
  if (data.teams?.length)
    filtersArray.push({
      tag: `Teams: ${data.teams.map((obj) => obj.name).join(',')}`,
      id: 'teams',
    });
  if (data.postedOnJobBoardBy?.length && data.postedOnJobBoardBy?.length > 0)
    filtersArray.push({
      tag: `Posted On Job Boards By: ${data.postedOnJobBoardBy.join(',')}`,
      id: 'postedOnJobBoardBy',
    });
  if (data.workplacePreference)
    filtersArray.push({
      tag: `Workplace Preference: ${data.workplacePreference}`,
      id: 'workplacePreference',
    });

  if (data.postedOnJobBoardFromDate && data.postedOnJobBoardToDate)
    filtersArray.push({
      tag: `Posted On Job Board Between: ${getDateUsingFormat(
        formattedDateISO(data.postedOnJobBoardFromDate),
        'DD-MM-YYYY'
      )} and ${getDateUsingFormat(formattedDateISO(data.postedOnJobBoardToDate), 'DD-MM-YYYY')}`,
      id: 'postedOnJobBoardBetween',
    });
  if (data.postedOnJobBoardName)
    filtersArray.push({
      tag: `Posted On ${data.postedOnJobBoardName}`,
      id: 'postedOnJobBoardName',
    });
  return filtersArray;
};

export const getJobIdsFromJobCode = (jobs: IJobSuggestions[], jobcodes: string[]) =>
  jobcodes
    .map((data) => {
      const match = data.match(/\(([^)]+)\)$/);
      const jobCodeToFind = match?.[1];
      return jobs.find((code) => code.jobCode === jobCodeToFind);
    })
    .filter(Boolean);

export const getJobTitlesWithCodes = (data: IJobSuggestions) => `${data?.title} (${data?.jobCode})`;
